import { faComments } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { saveJournal } from "../commonFetch";

import { RecruitmentRow1 } from "../components/DataRow";
import ToBack from "../components/ToBack";

const Enterprise = () => {
  const [data, setData] = useState({});

  const [list, setList] = useState([]);

  const [enterprise_user_id, setEnterpriseUserId] = useState([]);

  const auth = useSelector((state) => state.auth);

  const { id } = useParams();

  const { search } = useLocation();

  const [flag, setFlag] = useState(true);

  const fairId = new URLSearchParams(useLocation().search).get("fairId");
  const uuid = new URLSearchParams(useLocation().search).get("u_id");

  useEffect(() => {
    // 添加auth存在性检查，虽然从Redux获取的auth不会为null，但增加一层保护
    if (fairId > 0) {
      saveJournal({
        ref_id: auth?.id || 0,
        ref_id2: id || 0,
        fairId: fairId || 0,
        category: "参加招聘会并浏览企业详情",
        tag: "个人用户",
        ref_uuid: auth?.uuid || "",
        ref_uuid2: uuid || "",
      });
    } else {
      saveJournal({
        ref_id: auth?.id || 0,
        ref_id2: id || 0,
        fairId: 0,
        category: "浏览企业详情",
        tag: "个人用户",
        ref_uuid: auth?.uuid || "",
        ref_uuid2: uuid || "",
      });
    }
    // fetch(`/api/enterprise/${id}${search}`)
    fetch(`/api/simple/biz/employer/${id}/${uuid}`)
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          setData(res);
          fetch(`/api/simple/biz/employer-user?option=filterBy-refId&refId=${res.id}`)
            .then((res) => res.json())
            .then((res) => {
              setEnterpriseUserId(res?.id || 0);
            });
        } else {
          console.log("服务器错误，请稍后重试");
        }
      });
    // fetch(`/api/recruitment/enterprise/${id}${search}`)
    // fetch(`/api/biz/job?option=list-by-employer-id&id=${id}&uuid=${uuid}&status=在招`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     if (res.message) {
    //       alert("服务器错误，请稍后重试");
    //     } else {
    //       setList(res);
    //     }
    //   });
    fetch(`/gin-api/job?option=filterBy-refId&refId=${id}`)
      .then((response) => {
        if (response.status < 400) return response.json();
        throw new Error("请求数据失败");
      })
      .then((data) => {
        setList(data.filter((it) => it.status === "在招"));
      });
  }, [id, uuid]);

  const divShow = () => {
    setFlag(false);
    document.getElementById("btnshow").style.display = "block";
    document.getElementById("btnhref").innerHTML = "收起全文";
  };
  const divhidden = () => {
    setFlag(true);
    document.getElementById("btnshow").style.display = "-webkit-box";
    document.getElementById("btnhref").innerHTML = "展示全文";
  };

  return (
    <div className="container-fluid" style={{ fontSize: 14 }}>
      <div className="card border-0 shadow mt-2">
        <ToBack report dataType="企业" dataId={id} search={search} />
        <div className="card-body">
          <div className="row mt-2">
            <div className="col">
              <div className="row">
                <div className="col">
                  <h5 className="pull-left">{data.name}</h5>
                  <a
                    className="pull-right text-success"
                    href={`#消息/${data.name}/${enterprise_user_id}`}
                  >
                    <FontAwesomeIcon icon={faComments} fixedWidth />
                    咨询
                  </a>
                </div>
              </div>
              <span className="text-muted">
                {data.zhuziguimo} |{data.yuangongshuliang}
              </span>
              <br />
              <span className="text-muted">
                {data.addressLevel1}-{data.addressLevel2}-{data.addressLevel3}
              </span>
              <br />
              <span className="text-muted">
                详细地址:
                {data.addressLevel4}
              </span>
              <br />
              <span id="btnshow" className="text-muted intro-text">
                企业简介：
                {data.intro}
              </span>
              {flag === true ? (
                <p id="btnhref" className="pull-right text-danger" onClick={divShow}>
                  展开全文
                </p>
              ) : (
                <p id="btnhref" className="pull-right text-danger" onClick={divhidden}>
                  收起全文
                </p>
              )}
            </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col">
              <h6>在招职位</h6>
            </div>
          </div>
          {list &&
            list.map((item) => (
              <RecruitmentRow1
                key={item.id}
                {...item}
                fairId={fairId}
                id={Number.parseInt(item.id)}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Enterprise;
